export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/LoginIcon.1fb1987f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};